import actions from './actions';

const initState = {
    registros: [],
    resumen: [],
    loading: false,
};

export default function bonificacionesReducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_REPORTE_REQUEST:
        case actions.GET_RESUMEN_REQUEST:
            return { ...state, loading: true };

        case actions.GET_REPORTE_SUCCESS:
            return { ...state, loading: false, registros: action.payload };

        case actions.GET_RESUMEN_SUCCESS:
            return { ...state, loading: false, resumen: action.payload };

        default:
            return state;
    }
}
